import { createSliceSelectors } from '../utils'

const InteractiveElementsSelectors = createSliceSelectors('interactiveElements', [
    'openTriggerId', //currently open trigger id
    'isHotspotModalOpen',
    'interactiveElementsList',
    'interactiveElementsListState',
])

export default InteractiveElementsSelectors
